import React, { Component } from 'react';
import './style/App.scss';

import StepperContainer from './components/StepperContainer'

export default class App extends Component {
  render() {
    return (
      <div>
        <div className="background"></div>
        <div className="App">
          <StepperContainer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js